import { IntlKeys } from '../constants/IntlKeys';
import { GrowlMessageOptions } from '../types/Growl';
import { uuid } from './uuid';

export const errorGrowl = (messageKey?: string, fade = false): GrowlMessageOptions => ({
  id: uuid(),
  icon: 'error',
  fade,
  titleIntlKey: messageKey?.toUpperCase?.() || IntlKeys.UNKOWN_ERROR,
  contentIntlKey: IntlKeys.ERROR
});

export const successGrowl = (messageKey?: string, fade = true): GrowlMessageOptions => ({
  id: uuid(),
  icon: 'success',
  fade,
  fadeTime: 4000,
  titleIntlKey: messageKey?.toUpperCase?.(),
  contentIntlKey: IntlKeys.SUCCESS
});
